import { formatDateToString } from "./formatDateToString";

export const convertDateStringToReadableString = (date: string | null) => {
    if (date) {
        return formatDateToString(new Date(date));
    }
    return "";
};
